export default __webpack_public_path__ + "static/illustration-9-a405404c8e8dfda8a032eaec9fc25aae.png";